var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0066 6.78062L14.0083 9.19586C13.9913 9.42596 13.9694 9.65578 13.9426 9.88518C13.8977 10.2688 13.5859 10.5782 13.1943 10.622C11.9677 10.7591 10.6985 10.7591 9.47204 10.622C9.08043 10.5782 8.7686 10.2688 8.72373 9.88518C8.57722 8.6325 8.57722 7.36702 8.72373 6.11435C8.7686 5.73074 9.08043 5.42132 9.47204 5.37755C10.6985 5.24047 11.9677 5.24047 13.1943 5.37755C13.5859 5.42132 13.8977 5.73074 13.9426 6.11435C13.9685 6.33609 13.9898 6.55822 14.0066 6.78062ZM11.3331 6.99976C10.7809 6.99976 10.3331 7.44748 10.3331 7.99976C10.3331 8.55205 10.7809 8.99976 11.3331 8.99976C11.8854 8.99976 12.3331 8.55205 12.3331 7.99976C12.3331 7.44748 11.8854 6.99976 11.3331 6.99976Z",
    fill: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6022 4.02624C13.7059 4.20575 13.5113 4.40676 13.3053 4.38374C12.005 4.23841 10.6613 4.23841 9.36096 4.38374C8.51473 4.47832 7.83033 5.14468 7.7305 5.99818C7.57497 7.32804 7.57497 8.67149 7.7305 10.0013C7.83033 10.8549 8.51473 11.5212 9.36096 11.6158C10.6613 11.7611 12.005 11.7611 13.3053 11.6158C13.5127 11.5926 13.7088 11.795 13.6042 11.9755C13.0851 12.8708 12.1597 13.4955 11.0844 13.6087L10.6498 13.6544C8.44254 13.8867 6.21625 13.8714 4.01241 13.6088L3.72445 13.5745C2.53637 13.4329 1.595 12.5046 1.43676 11.3187C1.14283 9.11583 1.14283 6.8837 1.43676 4.68086C1.595 3.49489 2.53637 2.56665 3.72445 2.42507L4.01241 2.39076C6.21625 2.12814 8.44254 2.11283 10.6498 2.3451L11.0844 2.39083C12.1606 2.50408 13.0846 3.12982 13.6022 4.02624Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.dffeada1928513e1d9d7d7b215222b4d.svg";
export { ForwardRef as ReactComponent };